import { CircularProgress } from "@mui/material";

function Loader() {
  return <CircularProgress sx={{ color: "#223354" }} />;
}

export default Loader;
